import { AppModule } from 'app/module';
import { userDislike } from 'app/userDislike';
import 'module/icon/main';
import 'module/button/main';

import './styles.scss';
import Template from './template.hbs';

export class DislikeButton extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            label: '.m-dislikeButton__label',
            button: '.m-dislikeButton__button',
        };
    }

    getPropsFromDom() {
        return {
            label: this.dom.label ? this.dom.label.getAttribute('data-label') : '',
            buttonStyle: this.dom.button.classList.contains('m-watchlistButton__button--buttonStyle'),
            smallButton: this.dom.button.classList.contains('m-watchlistButton__button--small'),
        };
    }

    domEvents() {
        this.dom.el.addEventListener('click', (e) => this.eventClicked(e));
    }

    eventClicked(e) {
        e.stopPropagation();
        userDislike.checkForDislikeModal(this.props.id);
    }
}
